import get from 'lodash/get';

const styles = ({ margin, color }) => ({
  marginPanelContainer: {
    minHeight: '800px',
    padding: '0 36px',
  },
  paper: {
    paddingRight: '20px',
    marginTop: '20px',
  },
  helpIconContainer: {
    display: 'flex',
  },
  helpIcon: {
    fontSize: 20,
    margin: get(margin, 'm2'),
    verticalAlign: 'middle',
    cursor: 'pointer',
    color: `${get(color, 'link')} !important`,
  },
  idpInfoMessageContainer: {
    border: `1px solid ${get(color, 'borderColor')}`,
    display: 'inline-flex',
  },
  idpInfoMessage: {
    margin: 8,
  },
  infoIcon: {
    margin: 8,
  },
  userRolesLink: {
    cursor: 'pointer',
    fontSize: 12,
    color: `${get(color, 'link')} !important`,
  },
});

export default styles;
